module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAASRJREFUaEPtmu0JgzAQhs8NslG7WdvN7EYZoYgUpI0kr/ECiU/AP3oX8n6pESe72JguhtcAPLriKIzCgzGApQcT9A8OCqPwYAw0tXQI4W5my7Edc4xxbsVra8BPM3v8gHvFGJfzTQaAPWkOIaCwmWFpT5eRYU92yfDKLhn2dBkZ9mSXDJNhT3+tc5PhHMc7W7xc2/f6LbU9NLN36QS1W0tZ4Z0bz8H1VrfJz3AA5zhH4RxDvtebWDr1XaoUVn83rVJkqTretHjTqvFPWa/8WCqbNl2FpbF0jX/KerF0GU/HqsgwGT7mHKWLDCtsqbVkmAyrntHrW2f4Wr886Hqc39FU4fOXr88IYJ2zvjpQuC+99NWisM5ZXx0o3Jde+mpRWOesr44PMIi4PWoQ4MMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico_plus.png
// module id = Zc1m
// module chunks = 1